define( function() {

	// [[Class]] -> type pairs
	return {};
} );



//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/~/jquery/src/var/class2type.js
// module id = 236
// module chunks = 0